require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-china-global-roundup.json") })
        }
      }, "path---en-us-update-china-global-roundup");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-china-global-roundup!./.cache/json/en-us-update-china-global-roundup.json
// module id = 637
// module chunks = 231608221292675